var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"base-video mx-8",attrs:{"loop":"true","autoplay":"","controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.type}}),_vm._v("\n  Sorry, your browser doesn't support embedded videos.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }